'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMixin = require('react-mixin');

var _reactMixin2 = _interopRequireDefault(_reactMixin);

var _Checkbox = require('./Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _mixin = require('../mixin');

var _mixin2 = _interopRequireDefault(_mixin);

var CheckboxGroup = (function (_React$Component) {
    _inherits(CheckboxGroup, _React$Component);

    function CheckboxGroup() {
        _classCallCheck(this, CheckboxGroup);

        _get(Object.getPrototypeOf(CheckboxGroup.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(CheckboxGroup, [{
        key: 'handleChange',
        value: function handleChange(event) {
            var values = this.cloneObject(this.props.values);
            var index = values.indexOf(event.target.value);

            //Remove target value from the prop values
            if (index !== -1) {
                values.splice(index, 1);
            }

            if (event.target.checked === true) {
                values.push(event.target.value);
            }

            this.props.onChange(values);
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;

            // props
            var props = (0, _blacklist2['default'])(this.props, 'label', 'onChange', 'options', 'required', 'value');

            // classes
            var componentClass = (0, _classnames2['default'])(this.props.className);

            // dynamic elements
            var componentLabel = this.props.label ? _react2['default'].createElement(
                'label',
                { className: 'ComponentLabel' },
                this.props.label
            ) : null;

            // options
            var checkboxes = this.props.options.map((function (checkbox, i) {
                return _react2['default'].createElement(_Checkbox2['default'], _extends({
                    key: 'checkbox-' + i,
                    id: checkbox.value + '-' + i,
                    inline: props.inline,
                    checked: this.props.values.indexOf(checkbox.value) !== -1,
                    onChange: self.handleChange.bind(this),
                    name: props.name,
                    size: props.size
                }, checkbox));
            }).bind(this));

            return _react2['default'].createElement(
                'div',
                _extends({ className: componentClass }, props),
                componentLabel,
                checkboxes
            );
        }
    }]);

    return CheckboxGroup;
})(_react2['default'].Component);

CheckboxGroup.propTypes = {
    className: _propTypes2['default'].string,
    errors: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
    inline: _propTypes2['default'].bool,
    label: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].node]),
    onChange: _propTypes2['default'].func.isRequired,
    options: _propTypes2['default'].array.isRequired,
    size: _propTypes2['default'].oneOf(['lg']),
    values: _propTypes2['default'].arrayOf(_propTypes2['default'].string)
};

CheckboxGroup.defaultProps = {
    values: []
};

(0, _reactMixin2['default'])(CheckboxGroup.prototype, _mixin2['default']);

module.exports = CheckboxGroup;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/CheckboxGroup.js
// module id = 958
// module chunks = 0 1